// ConfirmDialog — opinionated confirm modal with two actions.
// Built on top of Modal so behavior stays consistent.

import Modal from './Modal'
import Button from '../buttons/Button'

export default function ConfirmDialog({
  open,
  onCancel,
  onConfirm,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'primary',
}) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      width={420}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel}>{cancelLabel}</Button>
          <Button variant={variant} onClick={onConfirm}>{confirmLabel}</Button>
        </>
      }
    >
      <div style={{ fontSize: 13, lineHeight: 1.5, color: 'var(--olv-text-secondary)' }}>
        {message}
      </div>
    </Modal>
  )
}
